import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const deleteAppConfModalSelector = createSelector(modalsSelector, (modals) => modals.deleteAppConf);

export default deleteAppConfModalSelector;
